/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import { type CmsIcon, CmsIconSchema } from '../models/icon'
import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type CouponApiProps = {
  technicalName?: Maybe<string>
  text: string
  icon?: Maybe<CmsIcon>
  infoLabel?: Maybe<string>
}

/* Schemas */
export const CouponApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  text: z.string(),
  icon: z.nullish(CmsIconSchema),
  infoLabel: z.nullish(z.string()),
})

/* Schemas validation */
type TestSimpleImage = ExpectTrue<
  Equal<CouponApiProps, z.infer<typeof CouponApiPropsSchema>>
>
